import React from "react"
import { Image } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import Authenticated from '../../lib/Authenticated'
import { getOrganization } from "../../lib/utils"
import apiServerApi from "../../redux/sagas/apiServerApi"

export default function OrganizationDetails() {

  const authenticated = new Authenticated(),

  savedOrg = getOrganization(),

  organization = savedOrg ? savedOrg : {},

  { id, name, iconId } = organization,

  icon = authenticated.isImpersonation() 
    ? <FontAwesome name='user-md' size="lg" className="ml-5" />
    : null

  return (
    <div className="p-10 sidebar-header flex items-center gap-10">

      <Image title={ name ? name : 'Logo' } alt={ name ? name : 'Logo' } width={32} height={32} circle
        src={ iconId
          ? apiServerApi.organizationIconURL(id)
          : require('../../files/company-logo.png') }
      />

      <div className="sidebar-header-info">

        { !!name && (
          <span className="sidebar-header-title w-100p truncate" title={ name }>
            { name }
          </span>
        )}

        <span className="sidebar-header-authority" title={ authenticated.getAuthority() }>
          { authenticated.getAuthority() } { icon }
        </span>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/App/OrganizationDetails.js